import { IconX } from '@developerz/ui';
import { createEffect, type JSX, Show, untrack } from 'solid-js';
import { t } from '../../i18n';
import { RELEASE_NOTE_MS } from '../../lib/send-work';
import type { SendWorkPage } from '../../lib/send-work-page';
import { createToast } from '../../lib/toast';
import { buttonClass } from '../ui/Button';

// The card's Send work notes (#6770), each shown for 7 s with a dismiss control, ONCE:
// - the back-to-the-queue note (Sending step 5, new copy): a task this page sent to this
//   machine that it did not start within its 10-minute hard target went back to the open
//   queue; showing it acknowledges the id, which disposes its read;
// - a late refusal or failure: a send whose form was closed or replaced before the answer
//   landed (#7686 review), in the same words the form's line would have shown.
// Showing a note acknowledges it (`SendWorkPage.acknowledge`). The timer is `createToast`'s,
// the app's one.

export function SendNote(props: {
  readonly boxId: string;
  readonly page: SendWorkPage;
}): JSX.Element {
  const note = createToast(RELEASE_NOTE_MS);
  createEffect(() => {
    const next = props.page.notes(props.boxId)[0];
    if (next === undefined) return;
    untrack(() => {
      note.notify(next.message, 'info');
      props.page.acknowledge(next.id);
    });
  });
  return (
    <Show when={note.toast()}>
      {(shown) => (
        <p class="mission-send__released" role="status">
          <span>{shown().message}</span>
          <button
            type="button"
            class={buttonClass({ variant: 'ghost', size: 'icon-sm' })}
            aria-label={t('fleet.send.dismiss')}
            title={t('fleet.send.dismiss')}
            onClick={note.dismiss}
          >
            <IconX />
          </button>
        </p>
      )}
    </Show>
  );
}
